import { Separator } from '@carboncopyco/ui';
import type { CloneActionsDropdownContentProps } from './types';

export const CloneActionsDropdownContent = ({
  duplicateClone,
  copyClone,
  continueCloning,
  copyUrl,
  archiveClone,
  openInStudio,
  moveClone,
  playVideo,
}: CloneActionsDropdownContentProps) => {
  return (
    <div className="p-2 flex flex-col">
      {/* Order of buttons is defined here */}
      {duplicateClone}
      {moveClone}
      {copyClone}
      {copyUrl}
      {continueCloning}
      {playVideo}
      {archiveClone && (
        <div className="py-2">
          <Separator horizontal />
        </div>
      )}
      {archiveClone}
      {openInStudio}
    </div>
  );
};
